// extracted by mini-css-extract-plugin
export var actionButton = "_np-0";
export var actionMenuContainer = "_np-i";
export var bubble = "_np-2";
export var bubbleActionMenu = "_np-j";
export var bubbleContext = "_np-6";
export var bubbleItems = "_np-7";
export var customer = "_np-3";
export var divider = "_np-8";
export var fileList = "_np-9";
export var hiddenComment = "_np-o";
export var infoAbove = "_np-a";
export var internal = "_np-4";
export var lightActionButton = "_np-1";
export var link = "_np-b";
export var merchant = "_np-5";
export var message = "_np-c";
export var profilePicture = "_np-e";
export var quillToolbarContainer = "_np-f";
export var senderDate = "_np-g";
export var senderDateCustomer = "_np-h";
export var senderName = "_np-d";
export var time = "_np-k";
export var uploadedImage = "_np-l";
export var username = "_np-m";
export var xsmall = "_np-n";